export default __webpack_public_path__ + "static/20-67178fd49973e52a0fd7b18e5389ee26.png";